import { Component, OnInit } from "@angular/core";
import { ApiPartnerService } from "../../api/api-partner.service";
import { ActivatedRoute, Router, ParamMap } from "@angular/router";
import { FormGroup, FormControl, FormBuilder, NgForm } from "@angular/forms";
// import { FormControl} from '@angular/forms';
import { LoadJsService } from "../../load-js/load-js.service";
import { URLSearchParams } from "@angular/http";

@Component({
  selector: "app-adminnextsys-manage-service-stb",
  templateUrl: "./adminnextsys-manage-service-stb.component.html",
  styleUrls: ["./adminnextsys-manage-service.component.css"],
})
export class AdminNextsysManageServiceSTBComponent implements OnInit {
  textSearch = new FormControl("");
  workorderList: any = [];
  STBList: any = [];
  ViewSTB: any = [];
  paging: any = [];
  Billingtype: any = [];
  Servicetype: any = [];
  partnername: any = [];

  msearch: string;
  //paging_link : any = [];
  page_self = [];
  page_next = [];
  page_prev = [];
  meta = [];
  last_index: number;
  first_index: number;
  total_count: number;
  querySearch = false;
  searching = false;
  dataempty = true;
  currentParams = {};
  queryParams = "";
  searchQueryParams = "";
  href = "";
  alert_act = "";
  alert_actmsg = "";
  myid: string;

  isOne = false;
  alert_failed = false;
  alert_success = false;

  table_load = false;
  table_data = false;

  formAct = this.fb.group({
    // id: [''],
    // Login_name: [''],
    // UserID: [''],
    dropaction: [""],
    actiondate: [""],
    note: [""],
  });

  formRegister = this.fb.group({
    // id: [''],
    nama: [""],
    alamat: [""],
    telp: [""],
    email: [""],
    email2: [""],
    servicetype: [""],
    billingtype: [""],
    note: [""],
  });

  constructor(
    public partnerService: ApiPartnerService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    public LoadJsOrder: LoadJsService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadStart();
  }

  loadStart() {
    this.route.queryParams
      //.filter(params => params.order)
      .subscribe((params) => {
        console.log(params); // {order: "popular"}

        let id = this.route.snapshot.paramMap.get("id");
        this.myid = id;

        this.loadBillingtype();
        this.loadServicetype();
        this.loadPartner();

        //this.order = params.order;
        //console.log(this.order); // popular

        if (params.search != "" && params.search != undefined) {
          this.msearch = params.search;
          this.querySearch = true;

          this.currentParams = params;
          this.queryParams = "?" + this.queryStr(params);
          this.loadSTB(id, this.queryParams);
        } else {
          this.querySearch = false;
          this.currentParams = params;

          this.queryParams = "?" + this.queryStr(params);
          console.log(this.queryParams);
          console.log(this.queryStr(params));
          /* pagination */
          //this.loadworkorder(this.currentParams);
          this.loadSTB(id, this.queryParams);

          //this.loadSTB(id);
        }
      });
  }

  refreshPage() {
    this.ngOnInit();
  }

  queryStr(options: any) {
    let params = new URLSearchParams();
    for (let key in options) {
      params.set(key, options[key]);
    }
    return params.toString();
  }

  cname(item: any) {
    if (item.pairingto == null || item.pairingto == 0) {
      return "-";
    } else {
      return item.customer.nama;
    }
  }
  cstatus(item: any) {
    if (item.customer == null || item.customer == 0) {
      return "-";
    } else {
      return item.customer.customerstatusname;
    }
  }
  cstatusid(item: any) {
    if (item.customer == null || item.customer == 0) {
      return "-";
    } else {
      return item.customer.customersts;
    }
  }

  _services(item: any) {
    let service = "";
    if (item.pairingto == null || item.pairingto == 0) {
      return service;
    } else {
      item.customer.services.forEach(function (value) {
        service += value.servicename + "\n";
      });

      return service.replace(/(\\r\\n)|([\r\n])/gim, ", ");
    }
  }

  copyMail() {
    // console.log(this.formRegister.value.email);
    this.formRegister.patchValue({
      email2: this.formRegister.value.email,
    });
  }

  onActionclick(act: any, id: any) {
    this.alert_act = act;
    console.log(act);

    // console.log("suspend")
    // this.clearForm();
    // this.isOne = true;

    return this.partnerService.GetViewStb(id).subscribe((output: any) => {
      this.ViewSTB = output.data;
      console.log(output.data);

      // this.formAct = output.data;
      // const data = {
      //   'id' : this.ViewSTB.id,
      //   'Login_name' : this.ViewSTB.macaddress,
      //   'UserID' : this.ViewSTB.macaddress
      // }
      // this.formAct.setValue(data);
      // console.log(output.data);
    });
  }

  // Issues list
  loadSTB(id: any, qParams) {
    this.table_load = true;
    return this.partnerService
    .GetViewPartnerSTBNextsys(id, qParams)
      .subscribe((output: any) => {
        this.STBList = output.data;
        // this.partnername = this.STBList[0].partnername;
        // console.log(this.STBList);

        this.table_load = false;

        // start pagination
        this.paging = output.pagex;
        this.page_self = output.pagex.self;
        this.page_next = output.pagex.next;
        this.page_prev = output.pagex.prev;
        this.meta = output.meta;
        this.total_count = this.meta["totalCount"];
        let self = this.page_self["page"];
        if (self * this.meta["perPage"] < this.meta["totalCount"]) {
          this.last_index = self * this.meta["perPage"];
        } else {
          this.last_index = this.meta["totalCount"];
        }

        this.first_index = (self - 1) * this.meta["perPage"] + 1;
        //end pagination

        // console.log(this.paging);
        //this.paging_link = this.STBList.paging.links;
      });
  }

  loadPartner() {
    let id = this.route.snapshot.paramMap.get("id");
    return this.partnerService.GetPartnername(id).subscribe((output: any) => {
      this.partnername = output.data;
      console.log(this.partnername);
    });
  }

  loadBillingtype() {
    return this.partnerService.GetBillingtype().subscribe((output: any) => {
      // console.log(output);
      this.Billingtype = output.data;
    });
  }

  loadServicetype() {
    return this.partnerService.GetProductsource().subscribe((output: any) => {
      // console.log(output);
      this.Servicetype = output.data;
    });
  }

  clearForm() {
    this.formRegister.reset();
    this.formAct.reset();
  }

  search() {
    this.querySearch = true;
    this.searchQueryParams = this.queryParams + "&search=" + this.msearch;
    this.loadSTB(this.myid, this.searchQueryParams);
  }

  redirectSetlayanan(params: any) {
    this.router.navigate([params]);
  }

  queryStrSearch() {
    if (this.msearch) {
      return "&search=" + this.msearch;
    } else {
      return "";
    }
  }
}
